// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__37fsR","clinicsSelect":"TableHeading_clinicsSelect__2VDEZ"};